/**
 * @generated SignedSource<<3bf8bd776666ad06ef66913afc65f613>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutNavigation_transaction$data = {
  readonly hasBuyerTaxError: boolean | null;
  readonly " $fragmentType": "CheckoutNavigation_transaction";
};
export type CheckoutNavigation_transaction$key = {
  readonly " $data"?: CheckoutNavigation_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutNavigation_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutNavigation_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasBuyerTaxError",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "676d893222e8ed0dd0da6f947bdf5cab";

export default node;
